// extracted by mini-css-extract-plugin
export default {"form":"ModelForm_form__LZeov","title":"ModelForm_title__DFaOR","input":"ModelForm_input__9Jhge","createBtn":"ModelForm_createBtn__09jcq","closeBtn":"ModelForm_closeBtn__DRouv"};